import {Fragment} from "react";
import React from "react";
import {distanceInWords, distanceInWordsToNow} from "date-fns";

const ColorBox = ({color}) => {
  const style = {
    width: 16,
    height: 16,
    background: color,
    display:"flex",
    margin: 6,
  };
  return <div style={style}/>
};

const NameList = ({teams}) => {
  return teams.map((team, index) => {
    return <Fragment key={index}><ColorBox color={team.color}/>{team.name}</Fragment>
  }).reduce((accumulated, current) => [accumulated, " | ", current])
};

const ScoreEntry = ({rank, teams, wave, score, start, end, version}) => {
  const diff = distanceInWordsToNow(end);
  const duration = distanceInWords(start, end);
  return <div className="ScoreBox">
    <div style={{display:"flex"}}>
      <div style={{width:60}}>
        <div className="ScoreKey">Rank</div>
        <div className="ScoreValue">{rank}.</div>
      </div>
      <div style={{flexGrow:1}}>
        <div className="ScoreKey">{teams.length > 1 ? "Players" : "Player"}</div>
        <div className="ScoreName" style={{display:"flex", alignItems: "center"}}>
          <NameList teams={teams}/>
        </div>
      </div>
      <div style={{width:60}}>
        <div className="ScoreKey">Wave</div>
        <div className="ScoreValue">{wave}</div>
      </div>
      <div style={{width:160}}>
        <div className="ScoreKey">Score</div>
        <div className="ScoreValue">{score}</div>
      </div>
    </div>
    <div className="ScoreFooter">
      logged {diff} ago | game duration: {duration} | version: {version}
    </div>
  </div>
};

const Spinner = () => {
  return <div className="spinner">
    <div className="bounce1"/>
    <div className="bounce2"/>
    <div className="bounce3"/>
  </div>
};

const ScoreList = ({matches}) => {
  if (!matches) {
    return null;
  }
  if (matches.length === 0) {
    return "No scores registered";
  }
  return matches.map((entry, index) => {
    const {wave, score, start, end, version, teams} = entry;
    const playerTeams = teams.filter(team => team.alliance === 0).map(team => ({name: team.name, color: team.color}));
    return <ScoreEntry
      key={index}
      rank={index + 1}
      teams={playerTeams}
      score={score}
      wave={wave}
      end={end}
      start={start}
      version={version}
    />;
  })

};

const HordeScores = ({matches, error}) => {
  return <Fragment>
    <h1>Horde Highscores</h1>
    {
      !matches && !error &&
      <Spinner/>
    }
    <ScoreList matches={matches}/>
    {
      error &&
        <div>
          {error}
        </div>
    }
  </Fragment>
};

export default HordeScores;



// WEBPACK FOOTER //
// ./src/HordeScores.js